function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336.41 337.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.2.71 41.5 42.5-104.5 104.5-41.5-41.5Zm63 63 41.5 42.5-167.5 167.5-41.5-41.5Zm-189 63 41.5 42.5-41.5 41.5-41.5-41.5Zm252 0 41.5 42.5-167.5 167.5-41.5-41.5Z",
    style: {
      fill: "#f0b90b",
      stroke: "#f0b90b"
    },
    "data-name": "Layer 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusd);
export default __webpack_public_path__ + "static/media/busd.ec73c3821b9d803507a5151733d328d8.svg";
export { ForwardRef as ReactComponent };